<template>
  <div class="batch-banner" :class="`batch-banner-${batch.status}`">
    <batch-status-badge :status="batch.status" size="md"/>
    <div class="batch-banner-message" v-html="message"></div>
  </div>
</template>

<script>
import BatchStatusBadge from './BatchStatusBadge.vue';

function escape(text) {
  return String(text || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

export default {
  components: {
    BatchStatusBadge,
  },
  props: {
    batch: {
      type: Object,
      required: true,
    },
  },
  computed: {
    lastEventBy() {
      const events = this.batch.events || [];
      const event = [...events].reverse().find(({ type }) => type === this.batch.status);
      return event && event.by && event.by.name ? event.by.name : null;
    },
    glossesOpen() {
      const byStatus = (this.batch.glosses && this.batch.glosses.byStatus) || {};
      return byStatus.open || { count: 0, value: 0 };
    },
    message() {
      switch (this.batch.status) {
        case 'closed':
          return this.batch.hasPaidFinancial
            ? 'Há repasse ou título pago: as guias não podem mais ser retiradas.'
            : 'Você ainda pode adicionar ou retirar guias.';
        case 'sent':
          return 'Aguardando a análise da operadora. '
            + 'Importe o demonstrativo assim que ela responder.';
        case 'analyzed':
          return this.glossesSentence;
        case 'in_appeal':
          return 'Recurso de glosa enviado. Aguardando a resposta da operadora.';
        case 'settled':
          return 'Guias encerradas. Nada mais a fazer neste lote.';
        case 'canceled':
          return `Cancelado${this.canceledBy}${this.cancelReason}. `
            + 'As guias voltaram para \'Aberta\'.';
        default:
          return '';
      }
    },
    glossesSentence() {
      const { count } = this.glossesOpen;
      if (count === 0) return 'Nenhuma glosa pendente de decisão. Baixe o lote quando a operadora pagar.';
      return `Há <b>${count} ${count === 1 ? 'glosa' : 'glosas'}</b> aguardando decisão: `
        + 'aceite ou recurse item a item.';
    },
    canceledBy() {
      return this.lastEventBy ? ` por <b>${escape(this.lastEventBy)}</b>` : '';
    },
    cancelReason() {
      return this.batch.cancelReason ? ` · ${escape(this.batch.cancelReason)}` : '';
    },
  },
};
</script>

<style lang="scss">
@import "./src/assets/scss/_variables.scss";
$amber-bg: #FFF8E6;
$amber-border: #F2C94C;

.batch-banner {
  align-items: center;
  background-color: $gray-color-ultra-light;
  border: $border-color-dark solid $border-width;
  border-radius: $border-radius;
  display: flex;
  flex-wrap: wrap;
  gap: $layout-spacing-lg;
  padding: $layout-spacing $layout-spacing-lg;
  .batch-banner-message {
    color: $gray-color-dark;
    flex: 1 1 14rem;
    font-size: $font-size-sm;
    b {
      color: $gray-color-900;
    }
  }
  &.batch-banner-sent {
    background-color: lighten($info-color, 48%);
    border-color: lighten($info-color, 34%);
  }
  &.batch-banner-analyzed, &.batch-banner-in_appeal {
    background-color: $amber-bg;
    border-color: $amber-border;
  }
  &.batch-banner-settled {
    background-color: #F2FAF5;
    border-color: #BFE3CD;
  }
  &.batch-banner-canceled {
    background-color: lighten($error-color, 38%);
    border-color: lighten($error-color, 20%);
  }
}
</style>
